<template>
    <div id="mainWrapper" :class="{'testView':testMode}">
		<modal v-if="showModal" @close="closeModal">
    		<h3 slot="header">Pinned Funds</h3>
			<div slot="body">
				Do you wish to pin <h3>{{ $store.state.chart.selectedFund.name }}?</h3>
			</div>
			<div slot="footer">
				<button class="btn modal-default-button" @click="closeModal">
					Cancel
              	</button>
				<button class="btn modal-default-button" @click="modalAction">
					{{ actionButton }}
              	</button>
			</div>
		</modal>

        <router-view></router-view>
        <scheme-loader v-if="showShemeLoader"></scheme-loader>
		<notifications group="note" position="top left" />
    </div>
</template>

<script>
import schemeLoader from '@/components/common/uiLayouts/loader.vue';
import modal from '@/components/common/uiLayouts/modal.vue';

export default {
    name: 'app',
    components: {
        schemeLoader,
        modal,
    },
    data () {
        return {
        };
    },
    created () {
        document.title = 'LCP Select';
    },
    computed: {
        showShemeLoader () {
            return this.$store.state.ui.pageState === 'loading';
        },
        showModal () {
            return this.$store.state.ui.showModal;
        },
        existingPin () {
            return this.$store.state.user.pinnedFunds.findIndex(i => i === this.$store.state.chart.selectedFund.ticker);
        },
        actionButton () {
            return this.existingPin === -1 ? 'Pin Fund' : 'Unpin Fund';
        },
    },
    methods: {
        closeModal () {
            this.$store.commit('ui/setShowModal', false);
        },
        modalAction () {
            if (this.existingPin > -1) {
                this.$store.commit('user/removePinnedFund', this.existingPin);
                this.closeModal();
            } else {
                this.$store.commit('user/addPinnedFund', this.$store.state.chart.selectedFund.ticker);
                this.closeModal();
            }
        },

    },
};
</script>

<style lang="scss">
@import 'src/assets/scss/all.scss';
html {
    overflow-y: scroll!important;
}
body {
    background-color: $bodyBg!important;
}
#mainWrapper {
	height: 100vh;
	overflow-y: hidden;
    background-color: $bodyBg;
    width: 100%;
    &.testView{
        background-color: #eee;
    }
}
.modal-default-button {
  float: right;
  margin-left: 20px;
	background: $darkBlue;
	border-radius: 6px;
	color: white;
	cursor: pointer;
	padding: 6px 12px;
	text-align: center;
}
</style>
